globalThis["__sentryRewritesTunnelPath__"] = undefined;
globalThis["SENTRY_RELEASE"] = {"id":"prod@2025.05.26"};
globalThis["__sentryBasePath"] = undefined;
globalThis["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from "@sentry/nextjs";

const sentryEnvironment = process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT;
const sentryRelease = process.env.NEXT_PUBLIC_SENTRY_RELEASE;
const sentryDist = process.env.NEXT_PUBLIC_SENTRY_DIST;

Sentry.init({
  dsn: "https://dcd7a0f8014e4939a653a95b1b55cca1@o420774.ingest.us.sentry.io/5339835",
  environment: sentryEnvironment,
  release: sentryRelease,
  dist: sentryDist,

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: sentryEnvironment === 'prod' ? 0.01 : 0,

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: sentryEnvironment !== 'prod',
  replaysOnErrorSampleRate: 1.0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: sentryEnvironment === 'prod' ? 0.01 : 0,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      // maskAllText: true,
      // blockAllMedia: true,
    }),
  ],
});
